import { jwtDecode } from "jwt-decode";

import axios from "axios";
import qs from "qs";
import { API_URL } from "../constants/data";

export const getAccessToken = () => localStorage.getItem("access_token");
export const getRefreshToken = () => localStorage.getItem("refresh_token");

export const setAccessToken = (token) => localStorage.setItem("access_token", token);
export const setRefreshToken = (token) => localStorage.setItem("refresh_token", token);

// --- Credential Management (WARNING: Not secure for production, but requested by user) ---
export const setCredentials = (username, password) => {
  // Simple base64 encoding to avoid plain text, but still easily reversible.
  const encoded = btoa(`${username}:${password}`);
  localStorage.setItem("user_creds", encoded);
};

export const getCredentials = () => {
  const encoded = localStorage.getItem("user_creds");
  if (!encoded) return null;
  try {
    const decoded = atob(encoded);
    const [username, password] = decoded.split(":");
    return { username, password };
  } catch (e) {
    return null;
  }
};

// --- Activity Tracking ---
export const updateLastActive = () => {
  localStorage.setItem("last_active", Date.now().toString());
};

export const getLastActive = () => {
  const last = localStorage.getItem("last_active");
  return last ? parseInt(last, 10) : 0;
};

export const isUserActive = (timeoutMs = 10 * 60 * 1000) => { // Default 10 mins (matches access token)
  const lastActive = getLastActive();
  return (Date.now() - lastActive) < timeoutMs;
};

export const removeTokens = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user_creds"); // Clear credentials
  localStorage.removeItem("last_active");

  // Clear application caches
  localStorage.removeItem("dashboardFilters");
  localStorage.removeItem("categoryDataCache");
  localStorage.removeItem("alertDataCache");
  localStorage.removeItem("stateDataCache");
  localStorage.removeItem("companyDataCache");
  localStorage.removeItem("currentSubcategoryData");
  localStorage.removeItem("subAlertCache");
  localStorage.removeItem("subStateDataCache");
  localStorage.removeItem("subCompanyCache");
  localStorage.removeItem("categoryAlertData");
  localStorage.removeItem("userDataCache");
  localStorage.removeItem("searchHistory");
};

export const isTokenExpired = (token) => {
  if (!token) token = getAccessToken();
  if (!token) return true;
  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decoded.exp < currentTime;
  } catch (e) {
    return true;
  }
};

let refreshInProgress = false;

export const refreshTokenIfExpiringSoon = async (thresholdSec = 2 * 60) => { // Refresh if < 2 mins remaining
  if (refreshInProgress) return null;

  const token = getAccessToken();
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    const now = Date.now() / 1000;

    if (decoded.exp - now > thresholdSec) return null;

    refreshInProgress = true;



    // Use stored refresh token since cookies are blocked by CORS
    const refreshToken = getRefreshToken();
    const response = await axios.post(`${API_URL}/refresh`,
      { refresh_token: refreshToken },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        withCredentials: true
      }
    );

    if (response.status === 200 && response.data.access_token) {
      setAccessToken(response.data.access_token);
      return response.data.access_token;
    }
  } catch (e) {
    console.error("Pre-expiry refresh failed", e);
  } finally {
    refreshInProgress = false;
  }

  return null;
};

